import AdmContactUsImg from "../../assets/AdmContactUs.svg";
import React from "react";
import SmallEnquiryForm from "../custom/SmallEnquiryForm";
import CustomHeading from "../custom/CustomHeading";

const ContactUs = () => {
  return (
    <div className="w-full overflow-x-hidden relative bg-[#FFF3ED] font-Lato px-[2%] sm:px-[6%] py-[4%] gap-[2rem] lg:h-[37rem] flex lg:flex-row flex-col items-start justify-between lg:pb-0 pb-[150px] sm:pb-[270px] ">
      {/* left section */}
      <div className="lg:w-[60%] font-normal  flex flex-col gap-3 ">
        <CustomHeading
          text={"Contact"}
          marginTop={"20px"}
          spanText={" Us"}
          spanTextColor="#d31c4f"
          showHeart={true}
          textSize="60px"
          leading="72px"
          smTextSize="30px"
        />
        <p className="text-2xl leading-8">
          Have an enquiry or Want to know how it works?
          <br />
          Fill the form!
        </p>
        <img
          src={AdmContactUsImg}
          alt="girlChild"
          className="absolute  z-[10] sm:left-0 lg:left-[6%] lg:w-[50%] bottom-0"
        />
      </div>
      <SmallEnquiryForm enquirySource={"Admission"} />
    </div>
  );
};

export default ContactUs;
